import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EmpresaListarComponent } from './empresa-listar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: EmpresaListarComponent }    
    ])],
    exports: [RouterModule]
})
export class EmpresaListarRoutingModule { }
